import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  outstandingActionsReminder: {
    display: 'flex',
    alignItems: 'center',
    '& .icon': {
      marginLeft: 0,
      marginRight: 10
    }
  }
})

export default useStyles
